<template lang='pug'>
  v-dialog(v-model="dialog" persistent max-width="500")

    template(v-slot:activator="{ on, attrs }")
      v-icon(
        @click="showAlert"
        class="mr-2"
        slot="activator" 
        small 
        title='Share URL' 
        color="blue" 
        v-bind="attrs"
        v-on="on"
      ) mdi-share-circle

    v-card
      v-card-title(class="headline grey lighten-3 mb-3") 
        v-icon(large color="blue") mdi-share-circle
        |&nbsp;&nbsp; Share URL
      b( v-if="step == 1" class="pl-6 pt-3" style="font-size: 14px;") 
        | Are you sure to generate specific url to user?

      a( v-if="step == 2" class="pl-6 pt-3" style="font-size: 14px;" :href="shareURL" target="blank") {{shareURL}}
      v-card-actions.pb-5
        v-spacer
        v-btn( depressed @click="step = 1; dialog = false" class="pl-4 pr-4" ) CLOSE
        v-btn( v-if="step == 1" color="blue-secondary"  depressed  @click="submit" class="pl-4 pr-4" ) YES, I SURE
        v-btn( v-if="step == 2" color="blue-secondary"  depressed  @click="copyURL" class="pl-4 pr-4" ) COPY URL

    v-overlay(:value="overlay")
      v-progress-circular(
        indeterminate
        size="64"
      )

</template>

<script>
import axios from "axios";
import * as i18n from "../data/i18n.json";
import { mapState } from "vuex";
export default {
  name: 'ShareURLDialog',
  props: {
    im: Object,
  },
  data: () => ({
    step:1,
    dialog: false,
    shareURL: '',
    duplicate: false,
    i18n: i18n.default,
    overlay: false,
    comment: '',
    rules: {
      length: len => v => (v || '').length <= len || `Comment must be less than 150 characters`,
    },
  }),
  computed: {
    isInputValid() {
      return this.comment != '' && this.comment.length <= 150
    }
  },
  methods: {
    copyURL() {
      navigator.clipboard.writeText(this.shareURL);
      this.$toasted.success('Success Copied', { icon: 'check_circle' });
    },
    async submit() {
      try {
        this.overlay = true
        let token = localStorage.getItem("token");
        const res = await axios({
          method: "get",
          url: process.env.VUE_APP_API_OLD+`/gen-shareurl/${this.im.imNo}`,
          headers: { Authorization: `Bearer ${token}` },
        })
        this.shareURL = res.data.url
        this.step = 2

      } catch (err) {
        let error = err.response.data.message || 'Err'
        if (error != 'Err') this.$toasted.error(error, { icon: "error" });
        else this.$toasted.error(error, { icon: "error" });
      } finally {
        this.overlay = false
      }

    }
  }
};
</script>
<style scoped>
    i.notif{
        margin-left: 1rem;
        font-size: 50px !important;
        color: #D42A2A !important;
    }
</style>
